import PaginationButtonRow from '@shared/components/core/button/PaginationButtonRow';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import SearchField from '@shared/components/core/search/SearchField';
import { StickyFooterStretch } from '@shared/components/core/structure/CommonBodyLayoutStyles';
import LicenseExpiredBannerCard from '@shared/components/license/LicenseExpiredBannerCard';
import SplashLoader from '@shared/components/loading/SplashLoader';
import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useCurrentOrgMemberFetching } from '@shared/hooks/useCurrentOrgMemberFetching';
import useCurrentOrgMemberSearch from '@shared/hooks/useCurrentOrgMemberSearch';
import { useTranslation } from 'react-i18next';
import OrgNoAccessBanner from '../banners/OrgNoAccessBanner';
import InviteEmptyBanner from '../invite/InviteEmptyBanner';
import MemberCardStack from './MemberCardStack';

export default function MemberPageContent() {
    const { currentOrg, hasSomeMemberEditPermissions, isExpiredOrg, canManageBilling, canViewMembers, membership } =
        useCurrentOrgDetailsFetching();
    const { isLoading } = useCurrentOrgMemberFetching();
    const membersSearch = useCurrentOrgMemberSearch();
    const { t } = useTranslation();
    const hasResults = (membersSearch.results?.length ?? 0) > 0;

    if (isLoading) return <SplashLoader />;
    if (!currentOrg || !membership) return <OrgNoAccessBanner />;

    if (isExpiredOrg)
        return <LicenseExpiredBannerCard organizationId={currentOrg.id} canManageBilling={canManageBilling} />;

    if (!(hasSomeMemberEditPermissions || canViewMembers)) return <OrgNoAccessBanner />;
    return (
        <>
            <SearchField
                value={membersSearch.searchQuery}
                onChange={(e) => membersSearch.handleSearchQueryChange(e.target.value)}
                onClear={() => membersSearch.handleSearchQueryChange('')}
            />
            {hasResults && <SubSectionRow title={t('common:results')} variant="small"></SubSectionRow>}
            {hasResults ? (
                membersSearch.results?.map((member) => (
                    <MemberCardStack
                        key={member.id}
                        member={member}
                        myRole={extractRoleProperties(membership)}
                        organizationId={currentOrg.id}
                    />
                ))
            ) : (
                <InviteEmptyBanner myRole={extractRoleProperties(membership)} organizationId={currentOrg.id} />
            )}
            <StickyFooterStretch $visuallyHide={!membersSearch.results || membersSearch.results.length == 0}>
                <PaginationButtonRow
                    onNext={membersSearch.handleNext}
                    onPrevious={membersSearch.handlePrevious}
                    disableNext={!membersSearch.showNext}
                    disablePrevious={!membersSearch.showPrevious}
                />
            </StickyFooterStretch>
        </>
    );
}
